import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';

export const isMainLocale = () => ![ELocale.NL_NL, ELocale.DA_DK, ELocale.NN_NO, ELocale.ES_ES, ELocale.SV_SE].includes(getLocale() as ELocale);
export const isSkiRentalsLocale = () => ![ELocale.EN_US].includes(getLocale() as ELocale);
